/**
 * Wrapper for lazy initialisation of objects
 */
export class Lazy<T> {

    private lazyValue: T | undefined;

    constructor(private initializer: () => T) { }

    /**
     * Initialize value if undefined and return it
     */
    get value(): T {
        if (!this.lazyValue) {
            this.lazyValue = this.initializer();
        }
        return this.lazyValue;
    }

    /**
     * Clear the lazyValue (set it back to undefined)
     */
    public clear(): void {
        this.lazyValue = undefined;
    }
}